import { de, enGB, fr, nlBE } from 'date-fns/locale';
import { create } from 'zustand';

import type { ApiAcceptedLanguage } from '@izimi/api';

const mapLanguageToLocale: Record<string, Locale> = {
  en: enGB,
  fr,
  nl: nlBE,
  de,
};

type LocaleStore = {
  locale: Locale;
  setLocale: (locale: ApiAcceptedLanguage) => void;
};

const initialState: LocaleStore = {
  locale: enGB,
  setLocale: () => {},
} as const;

export const useLocaleStore = create<LocaleStore>()((set, get) => ({
  ...initialState,
  setLocale: (locale) => {
    if (mapLanguageToLocale[locale] !== get().locale) {
      set({ locale: mapLanguageToLocale[locale] });
    }
  },
}));
